import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useSetupOnboardingPayout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post("onboarding/session/me/setup-payout"),
    onSuccess: ({ data }) => {
      queryClient.setQueryData(onboardingQKeys.session(), { data });
    },
  });
};
